// Elegant SVG placeholder for products (dark navy + cyan) — inlined as data-URI.
// Used when an image URL is broken or missing.

const svg = `<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 400 300'>
  <defs>
    <linearGradient id='g' x1='0' y1='0' x2='1' y2='1'>
      <stop offset='0%' stop-color='#0A1628'/>
      <stop offset='100%' stop-color='#050B14'/>
    </linearGradient>
  </defs>
  <rect width='400' height='300' fill='url(#g)'/>
  <g fill='none' stroke='rgba(0,229,255,0.35)' stroke-width='1.5'>
    <circle cx='200' cy='150' r='60'/>
    <circle cx='200' cy='150' r='36'/>
    <circle cx='200' cy='150' r='12' fill='rgba(0,229,255,0.6)'/>
  </g>
  <g fill='rgba(0,229,255,0.15)'>
    <rect x='30' y='30' width='30' height='2'/>
    <rect x='30' y='30' width='2' height='30'/>
    <rect x='340' y='30' width='30' height='2'/>
    <rect x='368' y='30' width='2' height='30'/>
    <rect x='30' y='268' width='30' height='2'/>
    <rect x='30' y='240' width='2' height='30'/>
    <rect x='340' y='268' width='30' height='2'/>
    <rect x='368' y='240' width='2' height='30'/>
  </g>
</svg>`;

export const PRODUCT_IMAGE_FALLBACK =
  "data:image/svg+xml;utf8," + encodeURIComponent(svg);
